import { inventoryApi } from '../api/inventoryApi'
import type { InventoryOutTransactionCreateData } from '../schema/inventorySchema'

export const recordOutTransaction = async (
  transaction: InventoryOutTransactionCreateData,
) => {
  try {
    const { data } = await inventoryApi.createOutTransaction(transaction)
    return data
  } catch (error) {
    console.error(`Error recording out transaction: `, error)
    throw error
  }
}
